import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  Router
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  routes: [{
      path: '/',
      name: 'Home',
      component: () => import('../views/Home.vue'),
      meta: {
        title: '首页',
      }
    },
    {
      path: '/SoftFunction',
      name: 'SoftFunction',
      component: () => import('../views/SoftFunction.vue'),
      meta: {
        title: '软件功能',
      }
    },
    {
      path: '/PricingStandards',
      name: 'PricingStandards',
      component: () => import('../views/PricingStandards.vue'),
      meta: {
        title: '定价标准',
      }
    },
    {
      path: '/UsingDocuments',
      name: 'UsingDocuments',
      component: () => import('../views/UsingDocuments.vue'),
      meta: {
        title: '使用文档',
      }
    },
    {
      path: '/Ai',
      name: 'Ai',
      component: () => import('../views/Ai.vue'),
      meta: {
        title: 'AI 助手',
      }
    },
    {
      path: '/ContactUs',
      name: 'ContactUs',
      component: () => import('../views/ContactUs.vue'),
      meta: {
        title: '联系我们',
      }
    },
    {
      path: '/Login',
      name: 'Login',
      component: () => import('../views/Login.vue'),
      meta: {
        title: '登录',
      }
    },
    {
      path: '/Register',
      name: 'Register',
      component: () => import('../views/Register.vue'),
      meta: {
        title: '注册',
      }
    },
    {
      path: '/Retrieve',
      name: 'Retrieve',
      component: () => import('../views/Retrieve.vue'),
      meta: {
        title: '重置密码',
      }
    },
    {
      path: '/PersonalCenter',
      name: 'PersonalCenter',
      component: () => import('../views/PersonalCenter.vue'),
      meta: {
        title: '个人中心',
      }
    },
    {
      path: '/Counter',
      name: 'Counter',
      component: () => import('../views/Counter.vue'),
      meta: {
        title: '计数器',
      }
    },
    {
      path: '/OrderDetails',
      name: 'OrderDetails',
      component: () => import('../views/OrderDetails.vue'),
      meta: {
        title: '计数器',
      }
    },
    {
      path: '/OrderFans/',
      name: 'OrderFans',
      component: () => import('../views/OrderFans.vue'),
      meta: {
        title: '计数器',
      }
    },
    {
      path: '/HistoryDetailed',
      name: 'HistoryDetailed',
      component: () => import('../views/HistoryDetailed.vue'),
      meta: {
        title: '计数器',
      }
    },
    {
      path: '/PublicOrder',
      name: 'PublicOrder',
      component: () => import('../views/PublicOrder.vue'),
      meta: {
        title: '分享工单',
      }
    },
    {
      path: '/PublicOrderFans',
      name: 'PublicOrderFans',
      component: () => import('../views/PublicOrderFans.vue'),
      meta: {
        title: '工单明细',
      }
    },
    {
      path: '/VoucherCenter',
      name: 'VoucherCenter',
      component: () => import('../views/VoucherCenter.vue'),
      meta: {
        title: '充值中心',
      }
    },
    {
      path: '/CustomerCenter',
      name: 'CustomerCenter',
      component: () => import('../views/CustomerCenter.vue'),
      meta: {
        title: '客户中心',
        theme: 'element-variables2'
      }
    },
    {
      path: '/PrivacyPolicy',
      name: 'PrivacyPolicy',
      component: () => import('../views/PrivacyPolicy.vue'),
      meta: {
        title: '隐私政策',
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js